import { render } from "./trasparenza.vue?vue&type=template&id=1df66f96&bindings={\"navigate\":\"props\"}"
import script from "./trasparenza.vue?vue&type=script&lang=js"
export * from "./trasparenza.vue?vue&type=script&lang=js"
script.render = render
/* custom blocks */
import block0 from "./trasparenza.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(script)


export default script